import { ActivityComponentType } from '@stackflow/react'
import { useCurrentUser } from '../../../modules/context/UserContext'
import useTranslation from '../../../modules/i18n/useTranslation'
import { useTutorStack } from '../../../pages/[lang]/webview/tutors'
import TutorSearchListBody from '../../student/new-portal/tutors/tutorSearchListBody'
import WebviewStackContainer from '../common/WebviewStackContainer'

interface ISearchTutor {
  params: {
    keyword: string
  }
}
const TutorSearchActivity: ActivityComponentType = ({ params }: ISearchTutor) => {
  const { t } = useTranslation()
  const { currentUser } = useCurrentUser()
  const { useTutorFlow } = useTutorStack()
  const { pop } = useTutorFlow()
  return (
    <WebviewStackContainer height="54px" onBack={pop}>
      <TutorSearchListBody currentUser={currentUser} initialKeyword={params.keyword} />
    </WebviewStackContainer>
  )
}

export default TutorSearchActivity
